const utils = {
  /**
   * @param {Function} func
   * @param {number} wait
   * @param {boolean} option.leading
   * @param {boolean} option.trailing
   */
  throttle: function (
    func,
    wait,
    option = {
      leading: true,
      trailing: true,
    }
  ) {
    let timeout = null;
    let lastCallContext = null;
    let lastCallArgs = null;

    const later = () => {
      if (option.trailing && lastCallArgs) {
        func.apply(lastCallContext, lastCallArgs);
        lastCallContext = null;
        lastCallArgs = null;

        // Set the timeout for trailing.
        // The func will execute only if the event was triggered again after
        // this execution, in other words, only if arguments of last function call
        // is stored.
        timeout = setTimeout(later, wait);
      } else {
        timeout = null;
      }
    };

    return function (...args) {
      if (timeout) {
        lastCallContext = this;
        lastCallArgs = args;
        return;
      }
      if (option.leading) {
        func.apply(this, args);
      } else {
        lastCallContext = this;
        lastCallArgs = args;
      }
      timeout = setTimeout(later, wait);
    };
  },
  debounce: function (func, delay) {
    let timeout;

    return function executedFunc(...args) {
      if (timeout) {
        clearTimeout(timeout);
      }

      timeout = setTimeout(() => {
        func(...args);
        timeout = null;
      }, delay);
    };
  },
  /**
   * 
   * @param {String} cname 
   * @param {String} cvalue 
   * @param {String} UTCExpireAt 
   * @param {Boolean} secure
   */
  setCookie: function (cname, cvalue, UTCExpireAt, secure=true) {
    let expires = "expires="+ UTCExpireAt;
    let secureField = secure?"Secure; SameSite=None":"";
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/"+secureField;
  },
  customerRequestHeaders:()=>{
    return {'shopify-customer-access-token':localStorage.getItem('vinyl_customer_access_token')}
  },
  saveCustomerAccessToken: (customerAccessToken, expiresAt)=>{
    localStorage.setItem("vinyl_customer_access_token",customerAccessToken);
    localStorage.setItem("vinyl_customer_access_token_expire",expiresAt);
    utils.customerRequestHeaders['shopify-customer-access-token']=localStorage.getItem('vinyl_customer_access_token');
  },
  getFullProductId: (productId="")=>{
    return productId && productId[0]=='g'?productId:("gid://shopify/Product/" + productId);
  },
  getShortProductVariantId: (variantId="")=>{
    if(!variantId) return "";
    //if variantId is full id with prefix "gid://shopify/ProductVariant/", then return short id
    if(variantId[0]=='g') return variantId.split("/ProductVariant/")[1];
    return variantId;
  },
  getShortProductId: (productId="")=>{
    if(!productId) return "";
    //if productId is full id with prefix "gid://shopify/ProductVariant/", then return short id
    if(productId[0]=='g') return productId.split("/Product/")[1];
    return productId;
  },
  getShortCustomerId: (customerId)=>{
    if (!customerId) return customerId;
    if (String(customerId).includes("gid://shopify/Customer/")) {
      return customerId.split("gid://shopify/Customer/")[1];
    } else {
      return String(customerId);
    }
  },
  /**
   * 
   * @param {String} dayMonthYear format DD-MM-YYYY
   * @returns 
   */
  dmyToTimestamp: (dayMonthYear)=>{
    if (!dayMonthYear || dayMonthYear === "") return "";
    const [day, month, year] = dayMonthYear.split("-").map(Number);

    // Months in JavaScript are 0-indexed, so we subtract 1 from the month
    const dateObject = (new Date(Date.UTC(year,month-1,day)));

    // Get the timestamp in milliseconds
    const timestamp = dateObject.getTime();
    return timestamp;
  },
  /**
   * 
   * @param {Number} timestamp milisecond
   * @returns Formatted Date with surffix: Ex: 2024 1st, 2023 2nd,...
   */
  timestampToFormattedDateWithSuffix: (timestamp) => {
    const dateObject = new Date(timestamp);
    const day = dateObject.getDate();
    
    // Options for formatting the date
    const options = { month: 'long' };
  
    // Convert the date to a formatted string
    const formattedDate = dateObject.toLocaleDateString('en-US', options);
  
    // Get the day suffix
    const daySuffix = getDaySuffix(day);
  
    // Add the day and suffix to the formatted date
    const formattedDateWithSuffix = `${formattedDate} ${day}${daySuffix}`;
  
    return formattedDateWithSuffix;
  },
  ACCOUNT_SUB_PAGES: {
    ORDERS: "#orders",
    WISHLIST: "#wishlist",
    SHIPPING: "#shipping",
    ACCOUNT: "#account",
    SETTINGS: "#settings",
  },
  getCookie: (cname) => {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  },
  // convert to date format: 17th May 2024
  formatDateWithSuffix: (dateString) => {
    const date = new Date(dateString);

    const day = date.getDate();
    const month = date.toLocaleString('default', { month: 'short' });
    const year = date.getFullYear();

    // Function to get ordinal suffix for the day
    function getOrdinalSuffix(day) {
        if (day > 3 && day < 21) return 'th'; // Covers 11th to 19th
        switch (day % 10) {
            case 1: return 'st';
            case 2: return 'nd';
            case 3: return 'rd';
            default: return 'th';
        }
    }

    const ordinalSuffix = getOrdinalSuffix(day);

    return `${day}${ordinalSuffix} ${month} ${year}`;
  },
  getLocation: ()=>{
    return new Promise((resolve, reject) => {
      fetch(PROXY_BASE_URL + "/customer-location",{
        method: 'get',
      }).then(async (response)=>{
        if(response.ok){
          const data = await response.json();
          if (data){
            resolve(data);
          }else{
            reject(new Error("No location found"));
          }
        }
      }).catch((error)=>{
        reject(error);
      });
    });
  },
  
  getIPVerification: async () => {
    const TIMEOUT_MS = 5000;
    const safeDefault = { isAllowed: true, id: null };

    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), TIMEOUT_MS);

    try {
      const response = await fetch(
        `${window.location.origin}/apps/${APP_PROXY_NAME}/api/proxycheck`,
        { method: 'GET', signal: controller.signal }
      );
      clearTimeout(timeoutId);

      if (!response.ok) {
        throw new Error(`Request failed: ${response.status}`);
      }

      const data = await response.json();

      if (!data) {
        throw new Error("No location found");
      }

      return data;
    } catch (error) {
      clearTimeout(timeoutId);
      // Never block the page: return safe default so Promise.all in theme.liquid
      // always resolves and handleCustomer() runs (e.g. when proxycheck is
      // pending on some pages like decades-collections).
      if (error?.name === 'AbortError' || error?.name === 'TimeoutError') {
        console.warn('getIPVerification: request timed out, using default (allowed)');
      }
      return safeDefault;
    }
  },

  // Known crawler / scraper / HTTP-library tokens. Deliberately conservative:
  // every token here is one that real browser user-agents (Mozilla/AppleWebKit/
  // Chrome/Safari/Firefox/Edg…) never contain, so matching cannot misclassify a
  // genuine visitor. Ambiguous in-app-browser tokens (e.g. WhatsApp) are left
  // out on purpose. `.test()` is stateless here (no `g` flag).
  BOT_UA_REGEX:
    /(?:bot\b|crawler|crawl|spider|slurp|mediapartners|googlebot|bingbot|bingpreview|yandexbot|baiduspider|duckduckbot|applebot|facebookexternalhit|facebot|twitterbot|linkedinbot|telegrambot|discordbot|slackbot|embedly|feedfetcher|scrapy|semrushbot|ahrefsbot|mj12bot|dotbot|dataforseobot|petalbot|headlesschrome|phantomjs|puppeteer|playwright|selenium|webdriver|lighthouse|gtmetrix|pingdom|uptimerobot|curl\/|wget\/|python-requests|python-urllib|go-http-client|node-fetch|okhttp|java\/|libwww|guzzle)/i,

  isBotUserAgent: (userAgent) => {
    if (!userAgent) return false;
    return utils.BOT_UA_REGEX.test(userAgent);
  },

  // VNYL-1466: a user-agent claiming an iOS device while `navigator.vendor` is
  // not Apple's. This is a HEURISTIC, not an invariant: across the iOS browser
  // population we actually observe, every browser is WebKit-backed and reports
  // vendor "Apple Computer, Inc." — in-app webviews (Facebook, Snapchat,
  // WeChat, NAVER…) included — so the mismatch is a high-confidence automation
  // signal rather than a proof. It is the same fall-through that makes
  // mixpanel-js report `$browser = "Mozilla"` for these hits: its detection
  // reaches the Safari branch only via `navigator.vendor`, so a spoofed UA that
  // leaves vendor untouched drops past it to the generic 'Gecko' → 'Mozilla'
  // case.
  //
  // `navigator.vendor` is deprecated (MDN), so this signal can decay. If WebKit
  // ever blanks it, genuine iOS users would start resolving to
  // 'ua_vendor_mismatch'. Two things contain that risk: we FLAG rather than
  // drop, so no event is lost either way; and the volume of bot_kind =
  // 'ua_vendor_mismatch' should be watched after deploy — a jump toward the
  // whole iOS population means the property changed, not that bots did.
  //
  // Deliberately iOS-only: `Macintosh` is NOT matched, because Chrome and
  // Firefox on macOS are genuine non-WebKit browsers reporting vendor
  // "Google Inc." / "" and would be misclassified.
  IOS_PLATFORM_UA_REGEX: /\b(?:iPhone|iPad|iPod)\b/,

  // Browser tokens mixpanel-js matches BEFORE it consults `navigator.vendor`.
  // A UA carrying one of these never lands in the 'Mozilla' bucket, so it is
  // outside the population this check targets. Skipping them also keeps the
  // check correct if a non-WebKit engine ever ships on iOS (EU alternative
  // browser engines), since such a browser would still announce itself here.
  NON_WEBKIT_BROWSER_TOKEN_REGEX:
    /(?:CriOS|FxiOS|EdgiOS|OPiOS|OPR\/|Edg[e]?\/|SamsungBrowser\/|UCBrowser|UCWEB|Whale\/|FBIOS)/,

  isSpoofedIosPlatform: (userAgent) => {
    if (!userAgent) return false;
    if (typeof navigator === 'undefined') return false;
    // Only decide when the browser actually exposes `vendor`. Treating an
    // absent property as a mismatch would flag any future engine that drops it.
    if (typeof navigator.vendor !== 'string') return false;
    if (!utils.IOS_PLATFORM_UA_REGEX.test(userAgent)) return false;
    if (utils.NON_WEBKIT_BROWSER_TOKEN_REGEX.test(userAgent)) return false;
    return navigator.vendor.indexOf('Apple') === -1;
  },

  checkToBlockTracking: ({userAgent, ipIsAllowed=true, isBot=false, botKind=null})=>{
    // Clear any block flag persisted in localStorage from the previous
    // (drop-the-event) behaviour, so events are no longer suppressed.
    window.mixpanel.register({"$ignore": false});

    // Resolve is_bot from HARD signals only. Each of these is extremely
    // unlikely to occur for a genuine visitor, so real users are NOT
    // misclassified as bots:
    //  - isBot:        client-side botd (headless / automation detection)
    //  - webdriver:    browser is under automation control
    //  - userAgent:    matches a known crawler / scraper token
    //  - spoofedIos:   UA claims an iOS device but navigator.vendor isn't Apple
    //  - !ipIsAllowed: IP layer (proxycheck) flagged the address
    const webdriver =
      typeof navigator !== 'undefined' && navigator.webdriver === true;
    const uaIsBot = utils.isBotUserAgent(userAgent);
    const spoofedIos = utils.isSpoofedIosPlatform(userAgent);

    let resolvedKind = null;
    if (isBot) resolvedKind = botKind || 'automation';
    else if (webdriver) resolvedKind = 'webdriver';
    else if (uaIsBot) resolvedKind = 'crawler_ua';
    else if (spoofedIos) resolvedKind = 'ua_vendor_mismatch';
    else if (!ipIsAllowed) resolvedKind = 'ip';

    // Flag bots instead of dropping their events: is_bot / bot_kind are
    // recorded on every event so they can be segmented/filtered in Mixpanel
    // (is_bot=false for real users) rather than making the events disappear.
    window.mixpanel.register({
      "is_bot": !!resolvedKind,
      "bot_kind": resolvedKind,
    });
    // VNYL-1435: expose the resolved verdict so non-tracking scripts (e.g. the
    // welcome popup gate in all.js) can read it without going through Mixpanel.
    window.__vinylBotCheck = { isBot: !!resolvedKind, botKind: resolvedKind };
    mixpanel.register({"User Agent": userAgent});
  },

  // VNYL-1435: report whether the current WebGL renderer is a software
  // rasterizer (SwiftShader / llvmpipe / Mesa / virgl). Real GPU-backed
  // browsers report a hardware vendor; headless / GPU-less Linux Chrome falls
  // back to software rendering, which is the tell the analytics is_bot verdict
  // misses. `no WebGL` is treated as NOT-a-bot to avoid flagging privacy
  // browsers that disable WebGL for real users.
  hasSoftwareWebGLRenderer: () => {
    try {
      const canvas = document.createElement('canvas');
      const gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
      if (!gl) return false;
      const ext = gl.getExtension('WEBGL_debug_renderer_info');
      if (!ext) return false;
      const renderer = String(gl.getParameter(ext.UNMASKED_RENDERER_WEBGL) || '').toLowerCase();
      return /swiftshader|llvmpipe|mesa|software|virgl/.test(renderer);
    } catch (e) {
      return false;
    }
  },

  // VNYL-1435: dedicated popup bot-gate. Deliberately MORE aggressive than the
  // analytics is_bot verdict — a false positive only means a real user misses
  // the discount popup (cheap), whereas ~60% headless/Linux traffic trips the
  // popup timer, never converts, and pollutes conversion data. Fails OPEN
  // (returns false on any error) so real users are never blocked by a bug.
  isLikelyBotForPopup: () => {
    try {
      const ua = (typeof navigator !== 'undefined' && navigator.userAgent) || '';

      // 1. Hard verdict from the analytics pipeline, if already resolved.
      if (window.__vinylBotCheck && window.__vinylBotCheck.isBot === true) return true;

      // 2. Browser under automation control.
      if (typeof navigator !== 'undefined' && navigator.webdriver === true) return true;

      // 3. Known crawler / headless / HTTP-library user-agent.
      if (utils.isBotUserAgent(ua)) return true;

      // 4. Headless/Linux tell: desktop Chrome rendering via a SOFTWARE WebGL
      //    backend. Restricted to non-touch desktop so real Android users
      //    (Linux-based, ~70% of traffic) are never affected.
      const isTouch =
        (typeof navigator !== 'undefined' && navigator.maxTouchPoints > 0) ||
        (typeof window !== 'undefined' && 'ontouchstart' in window);
      const looksDesktopChrome = /Chrome\//.test(ua) && !/Mobile/.test(ua);
      if (!isTouch && looksDesktopChrome && utils.hasSoftwareWebGLRenderer()) return true;

      return false;
    } catch (e) {
      return false; // fail open — show the popup rather than block a real user
    }
  },

  mixpanelRetryWrapper: {// mixpanel is not available for bot. need time to check if mixpanel is available. so we need to retry
    pendingTasks: new Set(['abTest', 'themeInit']),
    eventQueue: [],
    fallbackTimeoutStarted: false,
    removePendingTask: (taskName) => {
      utils.mixpanelRetryWrapper.pendingTasks.delete(taskName);
      if (utils.mixpanelRetryWrapper.pendingTasks.size === 0) {
        utils.mixpanelRetryWrapper.flushQueue();
      }
    },
    flushQueue: () => {
      while(utils.mixpanelRetryWrapper.eventQueue.length > 0) {
        const task = utils.mixpanelRetryWrapper.eventQueue.shift();
        if (task && task.type === 'register') {
          utils.mixpanelRetryWrapper.register(task.properties);
        } else if (task) {
          utils.mixpanelRetryWrapper.track(task.event, task.properties);
        }
      }
    },
    track: (event, properties) => {
      if (utils.mixpanelRetryWrapper.pendingTasks && utils.mixpanelRetryWrapper.pendingTasks.size > 0) {
        utils.mixpanelRetryWrapper.eventQueue.push({type: 'track', event, properties});
        if (!utils.mixpanelRetryWrapper.fallbackTimeoutStarted) {
          utils.mixpanelRetryWrapper.fallbackTimeoutStarted = true;
          setTimeout(() => {
            if (utils.mixpanelRetryWrapper.pendingTasks && utils.mixpanelRetryWrapper.pendingTasks.size > 0) {
              console.warn("Mixpanel pending tasks timeout, flushing queue. Pending:", Array.from(utils.mixpanelRetryWrapper.pendingTasks));
              utils.mixpanelRetryWrapper.pendingTasks.clear();
              utils.mixpanelRetryWrapper.flushQueue();
            }
          }, 5000);
        }
        return;
      }

      //if mixpanel able to track, track is a function, call track. If not, call retry. retry 3 times
      if (window.mixpanel && typeof window.mixpanel.track === 'function') {
        window.mixpanel.track(event, properties);
      } else {
        let retryCount = 0;
        const maxRetries = 3;

        const retry = () => {
          if (retryCount < maxRetries) {
            retryCount++;
            setTimeout(() => {
              try {
                console.log("Retrying mixpanel track: ", event, properties);
                window.mixpanel.track(event, properties);
              } catch (error) {
                console.log("Mixpanel not available yet, retrying...");
                retry();
              }
            }, 1000 * retryCount);
          }
        };

        retry();
      }
    },
    identify: (distinctId) => {
      if (window.mixpanel && typeof window.mixpanel.identify === 'function') {
        window.mixpanel.identify(distinctId);
      } else {
        let retryCount = 0;
        const maxRetries = 3;

        const retry = () => {
          if (retryCount < maxRetries) {
            retryCount++;
            setTimeout(() => {
              try {
                console.log("Retrying mixpanel identify: ", distinctId);
                window.mixpanel.identify(distinctId);
              } catch (error) {
                console.log("Mixpanel not available yet, retrying...");
                retry();
              }
            }, 1000 * retryCount);
          }
        };

        retry();
      }
    },
    register: (properties) => {
      if (utils.mixpanelRetryWrapper.pendingTasks && utils.mixpanelRetryWrapper.pendingTasks.size > 0) {
        utils.mixpanelRetryWrapper.eventQueue.push({type: 'register', properties});
        if (!utils.mixpanelRetryWrapper.fallbackTimeoutStarted) {
          utils.mixpanelRetryWrapper.fallbackTimeoutStarted = true;
          setTimeout(() => {
            if (utils.mixpanelRetryWrapper.pendingTasks && utils.mixpanelRetryWrapper.pendingTasks.size > 0) {
              console.warn("Mixpanel pending tasks timeout (register), flushing queue. Pending:", Array.from(utils.mixpanelRetryWrapper.pendingTasks));
              utils.mixpanelRetryWrapper.pendingTasks.clear();
              utils.mixpanelRetryWrapper.flushQueue();
            }
          }, 5000);
        }
        return;
      }

      if (window.mixpanel && typeof window.mixpanel.register === 'function') {
        window.mixpanel.register(properties);
      } else {
        let retryCount = 0;
        const maxRetries = 3;

        const retry = () => {
          if (retryCount < maxRetries) {
            retryCount++;
            setTimeout(() => {
              try {
                console.log("Retrying mixpanel register: ", properties);
                window.mixpanel.register(properties);
              } catch (error) {
                console.log("Mixpanel not available yet, retrying...");
                retry();
              }
            }, 1000 * retryCount);
          }
        };

        retry();
      }
    },
    reset: () => {
      if (window.mixpanel && typeof window.mixpanel.reset === 'function') {
        window.mixpanel.reset();
      } else {
        let retryCount = 0;
        const maxRetries = 3;

        const retry = () => {
          if (retryCount < maxRetries) {
            retryCount++;
            setTimeout(() => {
              try {
                console.log("Retrying mixpanel reset");
                window.mixpanel.reset();
              } catch (error) {
                console.log("Mixpanel not available yet, retrying...");
                retry();
              }
            }, 1000 * retryCount);
          }
        };

        retry();
      }
    },
    unregister: (property) => {
      if (window.mixpanel && typeof window.mixpanel.unregister === 'function') {
        window.mixpanel.unregister(property);
      } else {
        let retryCount = 0;
        const maxRetries = 3;

        const retry = () => {
          if (retryCount < maxRetries) {
            retryCount++;
            setTimeout(() => {
              try {
                window.mixpanel.unregister(property);
              } catch (error) {
                retry();
              }
            }, 1000 * retryCount);
          }
        };

        retry();
      }
    }
  }
};
function getDaySuffix(day) {
  if (day >= 11 && day <= 13) {
    return 'th';
  }

  const lastDigit = day % 10;

  switch (lastDigit) {
    case 1:
      return 'st';
    case 2:
      return 'nd';
    case 3:
      return 'rd';
    default:
      return 'th';
  }
}
